import React, {useContext, useState, useEffect, forwardRef, useImperativeHandle} from "react";
import "../../../ui-styles/conference/confHeader.css";
import { LangCtx } from "../../../lib/context";

const ConfHeader = forwardRef((props, ref) => {
    const { l } = useContext(LangCtx);
    const [count, setCount] = useState(0);

    useEffect(() => {
        setInterval(() => {
            setCount(prevState => prevState + 1);
        },1000);
    },[])

    // useEffect(() => {
    //     if(count > 160){
 
    //     }
    // },[count])

    useImperativeHandle(ref, () => ({
        saveLog: (id) => {
            // let body = {
            //     id: id,
            //     count: count,
            //     startTime: start,
            //     endTime: new Date().valueOf()
            // }
            // saveCallLogs(body).then(res => {
            //     console.log("res in save logs === ", res);
            // }).catch(err => {
            //     console.log("err in save logs ==== ", err);
            // })
        }
    }));

    const showTime = () => {
        if (count >= 3600) {
            let c = Math.floor(count % 3600);
            return ("0" + Math.floor(count/3600)).slice(-2)+":"+("0" + c).slice(-2)+":"+("0" + c%60).slice(-2);
        } else if (count >= 60) {
            return "00:"+("0" + Math.floor(count/60)).slice(-2)+":"+("0" + count%60).slice(-2);
        } else {
            return "00:00:"+("0" + count).slice(-2);
        }
    }

    return (
        <div className="confHeader">
            <div className="confRowBlock">
                <div className="confHdrToolsRow">
                    <div className="confToolsCntr">
                        <span className="confHdngTxtS">{l.inconsult}</span>
                        <span className="confTimerTxt">{showTime()}</span>
                    </div>
                    <div className="endBg active topEndClassBtn" onClick={props.handleEndCall}>
                        {/* <span className="mrgRight8"><img src="/images/icons/phone.png" alt="icon" className="invertWhite" /></span> */}
                        <span className="whiteTxt">{l.exit}</span>
                    </div>
                </div>
            </div>

        </div>
    )
})
export default ConfHeader;